/**
 * Timeline (uses Swiper.js)
 */
var component_timeline = function(args) {

  // setup args
  var timeline = args.timeline; // match this to $menu-visible SASS variable
  var top = timeline.querySelector('.timeline-top');
  var thumbs = timeline.querySelector('.timeline-thumbs');

  // Bottom gallery (thumbnails)
  if (thumbs.querySelectorAll('.swiper-slide').length > 1) {
    var timelineThumbs = new Swiper (thumbs, {
      // optional parameters
      //slidesPerView: 1,
      // slidesPerView: 'auto',
      spaceBetween: 24,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      touchRatio: 0, // disable dragging (would offset the position of the thumbnails)
    })
  }

  // Top gallery
  if (top.querySelectorAll('.swiper-slide').length > 1) {
    var timelineTop = new Swiper (top, {
      slidesPerView: 1,
      // optional parameters
      direction: 'horizontal',
      loop: false,
      grabCursor: true,
      spaceBetween: 24,
      autoHeight: true,
      // navigation arrows
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },

      // connect the thumbnail slider
      // thumbs: {
      //   swiper: {
      //     el: '.timeline-thumbs',
      //     slidesPerView: 'auto',
      //     centeredSlides: true,
      //     slideToClickedSlide: true,
      //   }
      // }
    });
    var timelineThumbs = new Swiper (thumbs, {
      // optional parameters
      //slidesPerView: 1,
      slidesPerView: 'auto',
      centeredSlides: true,
      slideToClickedSlide: true,
      spaceBetween: 24,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      touchRatio: 0, // disable dragging (would offset the position of the thumbnails)
    });
    timelineTop.controller.control = timelineThumbs;
    timelineThumbs.controller.control = timelineTop;

  } else {
    timelineTop.classList.add('disabled');
  }

  // make the call chainable
  return this;

};
